// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.captcha-container {\n  width: 304px;\n  margin: 0 auto;\n  overflow: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
